import { MaskLines, Overline } from "./Motion";

export const PageHero = ({ overline, lines, children, testId }) => (
  <section className="grain relative overflow-hidden bg-[var(--ink)] pb-16 pt-36 md:pb-24 md:pt-44" data-testid={testId}>
    <div className="grid-lines pointer-events-none absolute inset-0" />
    <div className="relative mx-auto max-w-[1440px] px-5 md:px-10">
      <Overline>{overline}</Overline>
      <MaskLines as="h1" onLoad delay={0.15} lines={lines} lineClass={(i) => (i === lines.length - 1 ? "text-outline" : "")}
        className="mt-6 font-display text-[15vw] font-black uppercase leading-[0.85] md:text-8xl lg:text-[9rem]" />
      {children}
    </div>
  </section>
);
